import Title from '@/components/Title.tsx';
import {Button, Menu, Popover} from '@blueprintjs/core';
import {ReactElement, ReactNode} from 'react';

interface Props {
	title: string,
	children?: ReactNode,
	rightElement?: ReactNode,
}

export default function TitleWithDropdown({title, children, rightElement}: Props): ReactElement {
	return (
		<Title title={title}>
			{children && (
				<Popover
					position="bottom-left"
					content={(
						<Menu>
							{children}
						</Menu>
					)}
				>
					<Button icon="chevron-down" variant="minimal" />
				</Popover>
			)}

			{rightElement && (
				<div style={{marginLeft: 'auto'}}>
					{rightElement}
				</div>
			)}
		</Title>
	);
}
